module.exports = __webpack_public_path__ + "img/dolde_rechts.2c0578f9.png";